export default __webpack_public_path__ + "static/media/bg-rave-1.b88b6550.m4v";